import { render, staticRenderFns } from "./AnnotationProjetolei.vue?vue&type=template&id=30bbd85a&scoped=true&"
import script from "./AnnotationProjetolei.vue?vue&type=script&lang=js&"
export * from "./AnnotationProjetolei.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationProjetolei.vue?vue&type=style&index=0&id=30bbd85a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30bbd85a",
  null
  
)

export default component.exports